import { WSFilter, WSFilterOption } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { queriesPayeeRows } from "@query";
import { selectorSearchRowName } from "../../../../../shared/selectors/selectorSearchRowName";

export function useBuildConfig() {
  // The only engagement identifier the v3 `listWorkLogs` filter accepts is
  // `payeeEngagementId` (the payer↔payee relationship), so the "Engagement"
  // filter lists the payer's payee-engagements keyed on it. Sourced from the v3
  // payee-row search — each row can hold several engagements.
  const queryPayees = queriesPayeeRows.searchPayeeRows.useQueryAll(
    { filter: { engagements_isWorkLoggingEnabled: { eq: true } } },
    { refetchOnMount: false, retry: false }
  );

  const engagementOptions = useMemo(
    (): WSFilterOption<"checkbox">[] =>
      (queryPayees.flatData || []).flatMap(payee =>
        (payee.engagements ?? [])
          .filter(
            engagement =>
              engagement.isWorkLoggingEnabled && !!engagement.payeeEngagementId
          )
          .map(engagement => ({
            name: engagement.payeeEngagementId as string,
            label: [selectorSearchRowName(payee), engagement.engagementName]
              .filter(Boolean)
              .join(" • ")
          }))
      ),
    [queryPayees.flatData]
  );

  return useMemo(
    (): WSFilter[] => [
      {
        title: "Engagement",
        name: "payeeEngagementId",
        type: "select",
        options: engagementOptions,
        searchable: true,
        loading: queryPayees.isLoading
      }
    ],
    [engagementOptions, queryPayees.isLoading]
  );
}
